import { IIntervention } from './Intervention.types';

export const initialIntervention : IIntervention = {
  date: null,
  type: "",
  pituaryTumor: ""
}